export const SET_IS_LOADING = 'COMISSIONED_REGISTRATION/SET_IS_LOADING';
export const SET_COMISSIONED = 'COMISSIONED_REGISTRATION/SET_COMISSIONED';
export const SET_COMISSIONED_ERRORS = 'COMISSIONED_REGISTRATION/SET_COMISSIONED_ERRORS';
export const CLEAR_COMISSIONED_ERRORS = 'COMISSIONED_REGISTRATION/CLEAR_COMISSIONED_ERRORS';
export const CLEAR_COMISSIONED = 'COMISSIONED_REGISTRATION/CLEAR_COMISSIONED';